import { useEffect, useRef } from 'react';
import { useApiIsLoaded, useMapsLibrary } from '@vis.gl/react-google-maps';

export function useInitGooglePlacesService() {
  const isLoaded = useApiIsLoaded();
  const placesLib = useMapsLibrary('places');

  const elementMapRef = useRef<HTMLDivElement | null>(
    document.createElement('div'),
  );
  const placesServiceRef = useRef<google.maps.places.PlacesService | null>(
    null,
  );
  const mapRef = useRef<google.maps.Map | null>(null);

  /**
   * initial placesServiceRef for getDetails address
   * (lat, lng, state, country, country code, zip, city)
   */
  useEffect(() => {
    if (!elementMapRef.current) return;
    if (!isLoaded || !placesLib) return;

    if (!mapRef.current) {
      mapRef.current = new window.google.maps.Map(elementMapRef.current);
    }

    if (!placesServiceRef.current) {
      placesServiceRef.current = new window.google.maps.places.PlacesService(
        mapRef.current,
      );
    }
  }, [elementMapRef, isLoaded, placesLib]);

  return {
    placesService: placesServiceRef.current,
  };
}
